






























































































import { Vue, Component } from 'vue-property-decorator'
import NPMPackage from '@/../package.json'
import PStorage, { SEND_CRASH_REPORTS, SEND_CRASH_FEEDBACK, stored } from '@/util/PStorage'
import { DBStore } from '@/data/db-store'

import SettingsHeader from '../components/SettingsHeader.vue'
import SettingsSection from '../components/SettingsSection.vue'
import SettingsRow from '../components/SettingsRow.vue'

/* eslint-disable indent */
@Component({
    name: 'about-panel',
    components: { SettingsHeader, SettingsSection, SettingsRow }
})
/* eslint-enable indent */
export default class AboutPanel extends Vue {
    /**
     * Application version
     */
    version: string = NPMPackage.version

    storedEntries: number = -1

    sendCrashReports: boolean = PStorage.getOrDefault(SEND_CRASH_REPORTS, true)
    sendCrashFeedback: boolean = PStorage.getOrDefault(SEND_CRASH_FEEDBACK, true)

    async mounted(): Promise<void> {
        this.storedEntries = await DBStore.entries.count()
    }

    /**
     * Clear application cache
     */
    async clearCache(): Promise<void> {
        (await caches.keys()).forEach(key => caches.delete(key))
        this.$success({ text: 'Application cache cleared successfully. Please refresh the page' })
    }

    async clearDatabase(): Promise<void> {
        await DBStore.entries.clear()
        // trigger refresh of data
        stored.dataLastUpdated = null
        this.$success({ text: 'Local database cleared successfully.' })
        this.storedEntries = await DBStore.entries.count()
    }

    setSendCrashReports(value: boolean): void {
        this.sendCrashReports = value
        stored.sendCrashReports = value
    }

    setSendCrashFeedback(value: boolean): void {
        this.sendCrashFeedback = value
        stored.sendCrashFeedback = value
    }
}
